import axios from 'axios';
import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import {
  MANAGE_SUBS_ALERTS_BEGIN,
  MANAGE_SUBS_ALERTS_SUCCESS,
  MANAGE_SUBS_ALERTS_FAILURE,
  MANAGE_SUBS_ALERTS_DISMISS_ERROR,
} from './constants';
import { API_REQUEST_URL } from '../../../common/apiConfig';
export function alerts(args = {}) {
  return (dispatch,getState) => { // optionally you can have getState as the second argument
    dispatch({
      type: MANAGE_SUBS_ALERTS_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const cognitoIdToken = getState().home.auth.cognitoIdToken;
      const token = `Bearer ${cognitoIdToken}`;
      const doRequest = axios.post(`${API_REQUEST_URL}/fetchManageDropOut`, args, {
        headers: {
          'Authorization': token,
        }
      });
      doRequest.then(
        (res) => {
          const data = res.data;
          dispatch({
            type: MANAGE_SUBS_ALERTS_SUCCESS,
            data: data,
          });
          resolve(data);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          const errorMsg = err && err.response ? err.response.data.message : 'There is an error. Please refresh page or contact administrator.';
          dispatch({
            type: MANAGE_SUBS_ALERTS_FAILURE,
            data: { error: errorMsg },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissAlertsError() {
  return {
    type: MANAGE_SUBS_ALERTS_DISMISS_ERROR,
  };
}

export function useAlerts() {
  const dispatch = useDispatch();

  const { alertsPending, alertsError } = useSelector(
    state => ({
      alertsPending: state.manageSubs.alertsPending,
      alertsError: state.manageSubs.alertsError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((...args) => {
    return dispatch(alerts(...args));
  }, [dispatch]);

  const boundDismissError = useCallback(() => {
    return dispatch(dismissAlertsError());
  }, [dispatch]);

  return {
    alerts: boundAction,
    alertsPending,
    alertsError,
    dismissAlertsError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case MANAGE_SUBS_ALERTS_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        alertsPending: true,
        alertsError: null,
      };

    case MANAGE_SUBS_ALERTS_SUCCESS:
      // The request is success
      return {
        ...state,
        alertsPending: false,
        alertsError: null,
      };

    case MANAGE_SUBS_ALERTS_FAILURE:
      // The request is failed
      return {
        ...state,
        alertsPending: false,
        alertsError: action.data.error,
      };

    case MANAGE_SUBS_ALERTS_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        alertsError: null,
      };

    default:
      return state;
  }
}
